angular.
module("dx.webapp.overview").
controller("DxOverviewInvigilatorController", function OverviewInvigilatorController(
	$scope,
	$filter,
	$interval,

	DX_EXAMS_STEPS,
	dxSession,
	dxApi,
	dxExamsFilters,
	dxSearchSortOptions,
	NodeRepository,
	Node,

	dxLocalize
) {
	"use strict";

	var self = this;

	self.dxSession = dxSession;

	self.node = new Node();
	self.loading = true;
	self.errors = {
		exams: "",
	};
	self.exams = {
		ongoing: [],
		scheduled: [],
		totalOngoing: 0,
		totalScheduled: 0,
	};

	NodeRepository.load(dxSession.getRole().organizationId).then(function onNodeLoadSuccess(node) {
		self.node = node;
	});

	function getExams() {
		dxApi.v1.exams.get().then(onGetExamsSuccess, onGetExamsError).finally(function onFinally() {
			if (self.loading) {
				self.loading = false;
			}
		});
	}

	function onGetExamsSuccess(res) {
		var exams = res.data;

		self.exams.ongoing = $filter("orderBy")(exams.filter(dxExamsFilters.ongoingExamsFilter), dxSearchSortOptions.ongoingExams.sortOptions[0].value);
		self.exams.scheduled = exams.filter(dxExamsFilters.scheduledExamsFilter).sort(dxSearchSortOptions.scheduledExams.sortOptions[0].value);

		self.exams.totalOngoing = self.exams.ongoing.length;
		self.exams.totalScheduled = self.exams.scheduled.length;

		return dxApi.v1.exams.shares.data.get().then(addInvigilatorSettings, onGetSettingsError);
	}

	self.addExamToOngoing = function addExamToOngoing(exam, step) {
		if (step !== DX_EXAMS_STEPS.ongoing) {
			return;
		}

		self.exams.ongoing.push(exam);
		self.exams.ongoing = $filter("orderBy")(self.exams.ongoing, dxSearchSortOptions.ongoingExams.sortOptions[0].value);
		self.exams.totalOngoing = self.exams.ongoing.length;
	};

	self.removeExamFromScheduled = function removeExamFromScheduled(exam, step) {
		if (step !== DX_EXAMS_STEPS.scheduled) {
			return;
		}

		self.exams.scheduled = self.exams.scheduled.filter(function remove(e) {
			return e.id !== exam.id;
		});

		self.exams.totalScheduled = self.exams.scheduled.length;
	};

	function onGetExamsError() {
		self.errors.exams = dxLocalize.get("Error.LoadingExams");
	}

	function addInvigilatorSettings(response) {
		var invigilatorSettings = response.data;
		for (var i = 0; i < self.exams.ongoing.length; i++) {
			var ongoingExam = self.exams.ongoing[i];
			ongoingExam.invigilatorSettings = findSettings(ongoingExam.id, invigilatorSettings);
		}

		for (var j = 0; j < self.exams.scheduled.length; j++) {
			var scheduledExam = self.exams.scheduled[j];
			scheduledExam.invigilatorSettings = findSettings(scheduledExam.id, invigilatorSettings);
		}
	}

	function findSettings(examId, settings) {
		for (var i = 0; i < settings.length; i++) {
			if (settings[i].objectId === examId) {
				return settings[i].data[0];
			}
		}

		return null;
	}

	function onGetSettingsError() {
		self.errors.exams = dxLocalize.get("Error.LoadingInvigilatorSettings");
	}

	getExams();
	self.updateExamsInterval = $interval(getExams, 10000);

	$scope.$on("$destroy", function destroy() {
		$interval.cancel(self.updateExamsInterval);
	});
});
